import invariant from 'tiny-invariant';

import { WritableConfiguratorStoreState } from '../../types';
import { ConfiguratorAction } from './types';

export type RemoveOperationDocumentAction = ConfiguratorAction<
  'removeDocument',
  { stepId: string; documentUuid: string }
>;

export const removeOperationDocument = (
  documentUuid: string,
  stepId: string,
): RemoveOperationDocumentAction => ({
  type: 'removeDocument',
  payload: {
    documentUuid,
    stepId,
  },
});

export function removeOperationDocumentAction(
  state: WritableConfiguratorStoreState,
  documentUuid: string,
  stepId: string,
) {
  const operation = state.blueprint.operations.find(
    (operation) => operation.stepId === stepId,
  );

  invariant(operation, 'Operation not found');

  if (!operation.documents) {
    return;
  }

  operation.documents = operation.documents.filter(
    (document) => document.id !== documentUuid,
  );
}
